import { ObjectOf } from 'types/global.types'
import { ChipColorType } from 'types/materialUI.types'
import {
  Disc as DiscIcon,
  CheckCircle as CheckCircleIcon,
  XCircle as XCircleIcon,
  DivideCircle as DivideCircleIcon,
} from 'react-feather'
import palette from 'theme/palette'

const PARTIAL_KIND = 'partial'
const FULL_KIND = 'full'
const DENIED_KIND = 'denied'

const ALL_TYPES_READING = [PARTIAL_KIND, FULL_KIND, DENIED_KIND] as const

const READING_TYPE_TRANSLATION = {
  [PARTIAL_KIND]: 'Aceito parcial',
  [FULL_KIND]: 'Aceito',
  [DENIED_KIND]: 'Recusado',
}

const READING_TYPE_CHIP_COLOR: ObjectOf<ChipColorType> = {
  [PARTIAL_KIND]: 'info',
  [FULL_KIND]: 'success',
  [DENIED_KIND]: 'error',
}

const CONSENT_DETAILS_DIALOG_ITEMS = [
  {
    title: 'Url do banner',
    value: (value?: string) => value,
  },
  {
    title: 'User-Agent',
    value: (value?: string) => value,
  },
  {
    title: 'Tipo:',
    value: (value?: string) => value,
  },
  {
    title: 'Data do consentimento:',
    value: (value?: string) => value,
  },
  {
    title: 'Tags aceitas:',
    value: (value?: string) => value,
  },
  {
    title: 'Tags recusadas',
    value: (value?: string) => value,
  },
]

const CONSENT_STATS_CARDS = [
  {
    key: 'bannersCount',
    icon: DiscIcon,
    label: 'BANNERS COM CONSENTIMENTOS',
    backgroundColor: palette.primary.main,
  },
  {
    key: 'fullCount',
    icon: CheckCircleIcon,
    label: 'CONSENTIMENTOS ACEITOS',
    backgroundColor: palette.success.main,
  },
  {
    key: 'deniedCount',
    icon: XCircleIcon,
    label: 'CONSENTIMENTOS RECUSADOS',
    backgroundColor: palette.error.main,
  },
  {
    key: 'partialCount',
    icon: DivideCircleIcon,
    label: 'CONSENTIMENTOS PARCIAIS',
    backgroundColor: palette.info.main,
  },
] as const

export type KindReadingType = (typeof ALL_TYPES_READING)[number]

export default {
  CONSENT_DETAILS_DIALOG_ITEMS,
  READING_TYPE_TRANSLATION,
  READING_TYPE_CHIP_COLOR,
  CONSENT_STATS_CARDS,
}
